module.exports = __webpack_public_path__ + "img/c965730.svg";